import { utilFunctionService } from "@/utils/utils.service"

/**
 * Authentication middleware for protected routes.
 * 
 * Preserves deep-link parameters (id, loId, moduleId) through the authentication flow:
 * - If user is not authenticated, redirects to login with original route name and params
 * - Parameters are passed as query strings to login page
 * - After successful login, Login.vue uses these params to redirect to the original destination
 * - learnerCentralLo then uses loId to navigate to specific learning object
 * - moduleId is used by setModuleData() to fetch and cache module information
 * 
 * @param {Object} context - Router context containing to and next
 */
export default function auth ({ to, next }) {
  if (!utilFunctionService.getLocalStorageService("instructor")) {
    const query = { name: to.name }

    if (to.params.id !== undefined) {
      query.id = to.params.id
      if (to.params.loId !== undefined) {
        query.loId = to.params.loId
      }
      if (to.params.moduleId !== undefined) {
        query.moduleId = to.params.moduleId
      }
    }

    if (to.query && to.query.user_section_id !== undefined) {
      query.user_section_id = to.query.user_section_id
    }

    if (to.query && to.query.message_type !== undefined) {
      query.message_type = to.query.message_type
    }

    return next({ name: 'login', query })
  }
  return next()
}
